export const removeTrailingSlash = (str: string): string => {
  return str.endsWith('/') ? str.slice(0, -1) : str;
};

export const removeLeadingSlash = (str: string): string => {
  return str.startsWith('/') ? str.substring(1) : str;
};

export const addTrailingSlash = (str: string): string => {
  // eslint-disable-next-line prefer-template
  return str.endsWith('/') ? str : str + '/';
};

// A minimalist helper, replace with library when needed
export const slugify = (str: string): string => {
  return str
    .toLowerCase()
    .replaceAll(' ', '-')
    .normalize('NFD') // è will decompose into e +  ̀
    .replace(/[\u0300-\u036f]/g, ''); // remove accents
};
